var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cpuExecutionTime && _vm.cpuExecutionTime != 'N/A')?_c('v-chip',{staticClass:"ml-3",staticStyle:{"text-transform":"capitalize","height":"36px","background-color":"white !important"},attrs:{"color":"black","outlined":"","label":""}},[_vm._v(" CPU Exec. Time: "+_vm._s(_vm.cpuExecutionTime)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }